import React from 'react'

export default function Required() {
  return (
    <div className="flex-row align-center color-red">
      <div style={{padding: `0 0 0 0.75rem`}}>* Required</div>
    </div>
  )
}
